import './style.scss';

import $ from "jquery";

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, EffectCoverflow, Parallax, Thumbs, Controller, FreeMode } from 'swiper/modules';
import 'swiper/css/bundle';


/*
* Slider Blocks
*/
var wazablockSliderInit = ( block ) => {
    const sliders = block.find('.swiper');
    let isThumbs = false;

    if ( sliders.length > 0 ) {
        let slider = block.find('.swiper')[0];
        let finalParams = {};

        const swiperArgs = {
            loop: true,
            slidesPerView: 1,
            modules: [ Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination, Scrollbar, Parallax, Thumbs, Controller ],
            autoplay: {
                enabled: false
            },
            navigation: {
                enabled: false
            },
            pagination: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            }
        };

        if ( slider.dataset.parameters != undefined && slider.dataset.parameters != '' ) {
            const dataParameters = JSON.parse(slider.dataset.parameters);

            if (dataParameters.navigation && dataParameters.navigation.enabled == true) {
                dataParameters.navigation.prevEl = block.find('.swiper-button-prev')[0];
                dataParameters.navigation.nextEl = block.find('.swiper-button-next')[0];
            }

            if (dataParameters.pagination && dataParameters.pagination.enabled == true) {
                dataParameters.pagination.el = block.find('.swiper-pagination')[0];
                dataParameters.pagination.type = 'bullets';
                dataParameters.pagination.clickable = true;
            }

            if (dataParameters.scrollbar && dataParameters.scrollbar.enabled == true) {
                dataParameters.scrollbar.el = block.find('.swiper-scrollbar')[0];
            }

            if (dataParameters.autoplay && dataParameters.autoplay.enabled == true) {
                dataParameters.autoplay.enabled = true;
            }

            // Thumbnails
            if (dataParameters.isThumbs && dataParameters.isThumbs == true) {
                isThumbs = true;
            }

            if (dataParameters.thumbs && dataParameters.thumbs.el != '') {
                const container = dataParameters.thumbs.el;
                const swiper = dataParameters.thumbs.el + ' .swiper';
                const el = document.querySelector(container);

                if ( el ) {
                    const swiperThumbs = new Swiper(swiper, {
                        loop: true,
                        slidesPerView: 2,
                        spaceBetween: 16,
                        modules: [Navigation, FreeMode],
                        freeMode: false,
                        autoplay: {
                            enabled: false
                        },
                        navigation: {
                            enabled: false,
                            prevEl: $(container).find('.swiper-button-prev'),
                            nextEl: $(container).find('.swiper-button-next')
                        },
                        pagination: {
                            enabled: false
                        },
                        scrollbar: {
                            enabled: false
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 3
                            },
                            1024: {
                                slidesPerView: 4
                            }
                        }
                    });
                    dataParameters.thumbs.swiper = swiperThumbs;
                }
            }

            finalParams = {
                ...swiperArgs,
                ...dataParameters
            };

        } else {
            finalParams = swiperArgs;
        }

        if ( !isThumbs ) {
            const swiper = new Swiper( slider, finalParams);
        }

    }
}

$(() => {
    $('.wazablocks__slider').each( function() {
        wazablockSliderInit( $(this) );
    });
});


// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction( 'render_block_preview/type=slider', wazablockSliderInit );
}